module.exports = __webpack_public_path__ + "media/home.10d90ad0.mp4";